import React from "react";
import { isBlank } from "../../../util/ext";
import { always, find, ifElse, lensProp, pipe, prop, view } from "ramda";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNoteSticky } from "@fortawesome/pro-regular-svg-icons";

import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

const getRejectionNote = pipe(
  find(prop("rejectionNote")),
  ifElse(isBlank, always("No reason given"), view(lensProp("rejectionNote"))),
);

const useStyles = makeStyles(theme => ({
  rejected: {
    color: theme.palette.rejected,
  },

  rejectedTooltip: {
    boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.15)",
    backgroundColor: "white",
    color: "black",
  },
}));

const RejectionNote = ({ content }) => {
  const classes = useStyles();

  if (isBlank(content.stipProperties)) {
    return "";
  }

  return (
    <Tooltip
      classes={{ tooltip: classes.rejectedTooltip }}
      title={
        <div>
          <Typography>
            <b>Reason:</b> {getRejectionNote(content.stipProperties)}
          </Typography>
        </div>
      }
    >
      <FontAwesomeIcon className={classes.rejected} icon={faNoteSticky} />
    </Tooltip>
  );
};

export default RejectionNote;
